module.exports = __webpack_public_path__ + "img/soccerboard119.925bb9ca.jpg";